import React from 'react';
import AdminPage from '../pages/AdminPage';

const AdminRoute: React.FC = () => <AdminPage />;

export default AdminRoute;
